import { useAmelioTranslations, useNavigate } from '@/hooks';
import {
    buildAssignProfileLocationState,
    buildAssignProfileSearch,
} from '@/navigation/assignProfileNavigation';
import { RouteName } from '@/navigation/types';

interface NoCompetenciesNoticeProps {
    employeeId: string;
}

export const NoCompetenciesNotice = ({ employeeId }: NoCompetenciesNoticeProps) => {
    const { t } = useAmelioTranslations();
    const navigate = useNavigate();

    const goToAssignCompetencyProfile = () => {
        const assignState = buildAssignProfileLocationState({
            employeeId,
            returnTo: RouteName.ManagerAssessment,
        });
        navigate({
            path: `${RouteName.CompetencyProfilesAdmin}${buildAssignProfileSearch(assignState)}`,
            state: assignState,
        });
    };

    return (
        <div
            role={'status'}
            className={
                'flex max-w-[775px] flex-col items-start gap-1 rounded-2xl border border-gray-200 bg-white/90 p-4 sm:p-6'
            }
            data-testid={'no-competencies-notice'}
        >
            <span className={'text-sm text-gray-900'}>
                {t('managerAssessmentSetup.noCompetenciesFound')}
            </span>

            <button
                type={'button'}
                className={
                    'text-primary focus-visible:ring-primary-800 rounded-sm text-sm font-medium underline focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2'
                }
                onClick={goToAssignCompetencyProfile}
                data-testid={'no-competencies-assign-profile'}
            >
                {t('managerAssessmentSetup.assignCompetencyProfile')}
            </button>
        </div>
    );
};
